import { app } from '../../app.module'
app
  // アカウント一覧に表示する、タグ一覧のディレクティブ
  .directive('accountTableTagList', () => {
    return {
      restrict: 'E',
      template: require('./account-table-tag-list.pug')(),
      scope: {
        tags: '=tags',
        accountId: '@accountId',
      },
      controller: function ($rootScope, $scope, accountTableTagListService) {
        // グローバルタグの一覧が文字列になっているので、オブジェクトに変換する
        if ($scope.tags.globalTagIds !== null) {
          const globalTags: {}[] = accountTableTagListService.Init.parseTags(
            $scope.tags.globalTagIds,
            $scope.tags.globalTagNames
          )

          $scope.globalTags = globalTags
        }

        // グループタグの一覧が文字列になっているので、オブジェクトに変換する
        if ($scope.tags.groupTagIds !== null) {
          const groupTags: {}[] = accountTableTagListService.Init.parseTags(
            $scope.tags.groupTagIds,
            $scope.tags.groupTagNames
          )

          $scope.groupTags = groupTags
        }

        // ユーザータグの一覧が文字列になっているので、オブジェクトに変換する
        if ($scope.tags.userTagIds !== null) {
          const userTags: {}[] = accountTableTagListService.Init.parseTags(
            $scope.tags.userTagIds,
            $scope.tags.userTagNames
          )

          $scope.userTags = userTags
        }

        /**
         * タグをクリックした場合はイベントを送信する
         * @param  {string} tagName クリックしたタグ名
         */
        $scope.searchTag = function (tagName: string) {
          $rootScope.$broadcast('clickAccountTableTag', tagName)
        }

        // 変更のあったディレクティブのみイベント受信するため、アカウントIDをイベント名に含める
        const eventName = 'changeTag_' + $scope.accountId

        // モーダルにてタグが新規追加された場合、変更を反映する
        const removeEvent = $rootScope.$on(eventName, (event, data) => {
          switch (data.tagRole) {
            case 'global':
              $scope.globalTags = data.newTags
              const globalTags = accountTableTagListService.Init.getTagsFromArray(data.newTags)

              $scope.tags.globalTagIds = globalTags.tagIds
              $scope.tags.globalTagNames = globalTags.tags
              break
            case 'group':
              $scope.groupTags = data.newTags
              const groupTags = accountTableTagListService.Init.getTagsFromArray(data.newTags)

              $scope.tags.groupTagIds = groupTags.tagIds
              $scope.tags.groupTagNames = groupTags.tags
              break
            case 'user':
              $scope.userTags = data.newTags
              const userTags = accountTableTagListService.Init.getTagsFromArray(data.newTags)

              $scope.tags.userTagIds = userTags.tagIds
              $scope.tags.userTagNames = userTags.tags
              break
          }
        })

        // ディレクティブが消える際には、$rootScopeのイベントの監視を削除
        $scope.$on('$destroy', () => {
          removeEvent()
        })
      },
    }
  })
